// extracted by mini-css-extract-plugin
export default {"landing__page":"landing_landing__page__43VJ5"};